import React from 'react';
import type { IconProps } from '../types';

export const IconFills: React.FC<IconProps> = ({ size = 20, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    {/* Fills icon - executed trades with checkmarks */}
    <rect x="2" y="3" width="16" height="14" rx="1" stroke={color} strokeWidth="1.5"/>
    {/* Filled checkmarks */}
    <path d="M5 7L7 9L9 7" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="13.5" cy="7.5" r="1.5" fill={color} fillOpacity="0.8"/>

    <path d="M5 10.5L7 12.5L9 10.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="13.5" cy="11" r="1.5" fill={color} fillOpacity="0.6"/>

    <path d="M5 14L7 16L9 14" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="13.5" cy="14.5" r="1.5" fill={color} fillOpacity="0.4"/>
  </svg>
);
